//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";


// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import HeaderStepCampanha from './HeaderStepCampanha';


// services
import { MaskDate, formateDate, convertDate, validateDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);

export default function IdentificacaoCampanha({ item, handleCancelar, handleProximoStep, disabledform }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, handleSubmit, setValue, clearError, errors, getValues } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };

    const TiposCampanha = [
        { id: 0, title: 'Selecione' },
        { id: 1, title: 'Aniversariante' },
        { id: 2, title: 'Pacote' },
        { id: 3, title: 'Servico' },
        { id: 4, title: 'Cortesia' },
        { id: 5, title: 'CanalMidia' },
        { id: 6, title: 'Profissao'}
    ];

    const TipoAniversariante = [
        { id: 0, title: 'Selecione' },
        { id: 1, title: 'Anual' },
        { id: 2, title: 'Mensal' },
    ];
    const [campanhaId, setcampanhaId] = React.useState(0);
    const [disableTipo, setdisableTipo] = React.useState(false);

    useEffect(() => {

        if (item != null && item.campanhaId != 0) {
            setdisableTipo(true);
            LoadItensCampanha();
        }
        else if (item != null && item.campanhaId == 0) {
            setdisableTipo(false);
            LoadItensCampanha();
        }
        else {
            setdisableTipo(false);
        }

    }, [item]);

    const LoadItensCampanha = () => {

        setcampanhaId(item.campanhaId);
        setValue('nome', item.nome);
        setValue('vigenciade', formateDate(item.vigenciaDe));
        setValue('vigenciaate', formateDate(item.vigenciaAte));
        setValue('tipocampanha', item.tipoCampanha);
        settipoCampanha(item.tipoCampanha);

        if (item.campanhaAniversariantes != null && item.campanhaAniversariantes.length > 0) {
            handleTipoCampanha(item.tipoCampanha);// ja habilita os cammpos de visualização e carrega os campos de aniversariante
            settipoAniversariante(item.campanhaAniversariantes[0].tipoFiltros);
            setValue('tipoaniversariante', item.campanhaAniversariantes[0].tipoFiltros);
            setvalorreferencia(item.campanhaAniversariantes[0].valorReferencia);
        }
        if (item.campanhaPacotes != null && item.campanhaPacotes.length > 0) {
            handleTipoCampanha(item.tipoCampanha);// ja habilita os cammpos de visualização e carrega o loadPacote
            let pacotesSelected = [];
            item.campanhaPacotes.map(obj => { pacotesSelected.push(obj.pacoteId) });
            setjsonPacote(pacotesSelected);

        }
        if (item.campanhaServicos != null && item.campanhaServicos.length > 0) {
            handleTipoCampanha(item.tipoCampanha);// ja habilita os cammpos de visualização e carrega o loadServicos
            let servicosSelected = [];
            item.campanhaServicos.map(obj => { servicosSelected.push(obj.servicoId) });
            setjsonServico(servicosSelected);
        }
        if (item.campanhaCanaisMidias != null && item.campanhaCanaisMidias.length > 0) {
            handleTipoCampanha(item.tipoCampanha);// ja habilita os cammpos de visualização e carrega o CanaisMidia
            let midiasSelected = [];
            item.campanhaCanaisMidias.map(obj => { midiasSelected.push(obj.canalMidiaId) });
            setjsonCanalMidia(midiasSelected);
        }
        if (item.campanhaCortesias != null && item.campanhaCortesias.length > 0) {
            handleTipoCampanha(item.tipoCampanha); // ja habilita os cammpos de visualização e carrega os campos de Cortesia
            setperiodode(formateDate(item.campanhaCortesias[0].periodoDe));
            setperiodoate(formateDate(item.campanhaCortesias[0].periodoAte));
        }
        if (item.campanhaProfissoes != null && item.campanhaProfissoes.length > 0){
            handleTipoCampanha(item.tipoCampanha);
            let profissoesSelected = [];
            item.campanhaProfissoes.map(obj => { profissoesSelected.push(obj.profissaoId) });
            setjsonProfissao(profissoesSelected);
        }
    }

    const [tipoCampanha, settipoCampanha] = React.useState(0);
    const [descricaoTipo, setdescricaoTipo] = React.useState("");
    const handleTipoCampanha = (value) => {
        if (value != 0) {
            settipoCampanha(value);
            if (value == 1) {
                setselectedCampanhaAviversariante(true);
                setselectedCampanhaPacote(false);
                setselectedselectedCampanhaServico(false);
                setselectedCampanhaCortesia(false);
                setselectedCampanhaCanalMidia(false);
                setselectedCampanhaProfissao(false);
                setdescricaoTipo("Nesta campanha o sistema realiza uma pesquisa com o Mês informado ou ano atual retornando os aniversariantes no período.");
            }
            if (value == 2) {
                LoadSelectPacotes();
                setselectedCampanhaPacote(true);
                setselectedCampanhaAviversariante(false);
                setselectedselectedCampanhaServico(false);
                setselectedCampanhaCortesia(false);
                setselectedCampanhaCanalMidia(false);
                setselectedCampanhaProfissao(false);
                setdescricaoTipo("Nesta campanha o sistema realiza uma pesquisa com os Pacotes selecionados retornando uma lista de clientes que executaram esses pacotes.");
            }
            if (value == 3) {
                LoadSelectServicos();
                setselectedselectedCampanhaServico(true);
                setselectedCampanhaPacote(false);
                setselectedCampanhaAviversariante(false);
                setselectedCampanhaCortesia(false);
                setselectedCampanhaCanalMidia(false);
                setselectedCampanhaProfissao(false);
                setdescricaoTipo("Nesta campanha o sistema realiza uma pesquisa com os Serviços selecionados retornando uma lista de clientes que executaram esses pacotes.");
            }
            if (value == 4) {
                setselectedCampanhaCortesia(true);
                setselectedselectedCampanhaServico(false);
                setselectedCampanhaPacote(false);
                setselectedCampanhaAviversariante(false);
                setselectedCampanhaCanalMidia(false);
                setselectedCampanhaProfissao(false);
                setdescricaoTipo("Nesta campanha o sistema realiza uma pesquisa retornando todos os clientes que não efetuaram nenhuma venda no período informado.");
            }
            if (value == 5) {
                LoadSelectCanalMidias();
                setselectedCampanhaCanalMidia(true);
                setselectedselectedCampanhaServico(false);
                setselectedCampanhaPacote(false);
                setselectedCampanhaAviversariante(false);
                setselectedCampanhaCortesia(false);
                setselectedCampanhaProfissao(false);
                setdescricaoTipo("Nesta campanha o sistema realiza uma pesquisa com os Canais de Mídia selecionados retornando os clientes que fizeram Avaliações informando estes canais.");
            }
             if (value == 6) {
                LoadSelectProfissoes();
                setselectedCampanhaProfissao(true);
                setselectedCampanhaCanalMidia(false);
                setselectedselectedCampanhaServico(false);
                setselectedCampanhaPacote(false);
                setselectedCampanhaAviversariante(false);
                setselectedCampanhaCortesia(false);
                setdescricaoTipo("Nesta campanha o sistema realiza uma pesquisa retornando todos os clientes que estão cadastrados com as profissões inseridas.");
            }
        }
    };
    //CampanhaAniversariante
    const [selectedCampanhaAviversariante, setselectedCampanhaAviversariante] = React.useState(false);
    const [tipoAniversariante, settipoAniversariante] = React.useState(0);
    const [valorreferencia, setvalorreferencia] = React.useState("");

    // Filtros
    const [DisabledAnual, setDisabledAnual] = React.useState(true);

    const handleTipoAniversariante = (value) => {

        if (value != 0) {
            settipoAniversariante(value);

            if (value == 1) {
                setDisabledAnual(true);
                let now = new Date();
                let year = now.getFullYear().toString();

                setValue('valoreferencia', year);
            }
            else {
                setDisabledAnual(false);
                setValue('valoreferencia', "");

            }
        }

    }
    //Campanha Pacote
    const [selectedCampanhaPacote, setselectedCampanhaPacote] = React.useState(false);
    const [isLoadingPacote, setisLoadingPacote] = React.useState(false);
    const [listSelectPacotes, setlistSelectPacotes] = React.useState([]);
    const [jsonPacote, setjsonPacote] = React.useState([]);

    const LoadSelectPacotes = () => {
        setisLoadingPacote(true);
        const endPoint = "pacotes/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setisLoadingPacote(false);
                return false;
            }
            setlistSelectPacotes(result.data);
            setisLoadingPacote(false);
            return true;
        });
    }
    const handlePacoteChange = event => {
        let value = event

        let lstsAdd = [];

        value.map(obj => { lstsAdd.push(obj.pacoteId); });
        setjsonPacote(lstsAdd);
    };

    //Campanha Serviço
    const [selectedCampanhaServico, setselectedselectedCampanhaServico] = React.useState(false);
    const [isLoadingServico, setisLoadingServico] = React.useState(false);
    const [listSelectServicos, setlistSelectServicos] = React.useState([]);
    const [jsonServico, setjsonServico] = React.useState([]);

    const LoadSelectServicos = () => {
        setisLoadingServico(true);
        const endPoint = "servicos/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setisLoadingServico(false);
                return false;
            }
            setlistSelectServicos(result.data);
            setisLoadingServico(false);
            return true;
        });
    }
    const handleServicoChange = event => {
        let value = event

        let lstsAdd = [];

        value.map(obj => { lstsAdd.push(obj.servicoId); });
        setjsonServico(lstsAdd);
    };
    //Campanha Canal Midia
    const [selectedCampanhaCanalMidia, setselectedCampanhaCanalMidia] = React.useState(false);
    const [isLoadingCanalMidia, setisLoadingCanalMidia] = React.useState(false);
    const [listSelectCanalMidia, setlistSelectCanalMidia] = React.useState([]);
    const [jsonCanalMidia, setjsonCanalMidia] = React.useState([]);

    const LoadSelectCanalMidias = () => {
        setisLoadingCanalMidia(true);
        const endPoint = "midia/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setisLoadingServico(false);
                return false;
            }
            setlistSelectCanalMidia(result.data);
            setisLoadingCanalMidia(false);
            return true;
        });
    }
    const handleCanalMidiaChange = event => {
        let value = event

        let lstsAdd = [];

        value.map(obj => { lstsAdd.push(obj.canalMidiaId); });
        setjsonCanalMidia(lstsAdd);
    };

    //Campanha Profissao 
    const [selectedCampanhaProfissao, setselectedCampanhaProfissao] = React.useState(false);
    const [isLoadingProfissao, setisLoadingProfissao] = React.useState(false);
    const [listSelectProfissoes, setlistSelectProfissoes] = React.useState([]);
    const [jsonProfissao, setjsonProfissao] = React.useState([]);

    const LoadSelectProfissoes = () => {
        setisLoadingProfissao(true);
        const endPoint = "profissao/ativos/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setisLoadingProfissao(false);
                return false;
            }
            setlistSelectProfissoes(result.data);
            setisLoadingProfissao(false);
            return true;
        });
    }
    const handleProfissaoChange = event => {
        let value = event

        let lstsAdd = [];

        value.map(obj => { lstsAdd.push(obj.profissaoId); });
        setjsonProfissao(lstsAdd);
    };

    // //Campanha Cortesia
    const [selectedCampanhaCortesia, setselectedCampanhaCortesia] = React.useState(false);
    const [periodode, setperiodode] = React.useState("");
    const [periodoate, setperiodoate] = React.useState("");

    //cancelar form
    const handleCancelarForm = () => {
        handleCancelar();
    };

    //Próximo step Campanha
    const [LoadingForm, setLoadingForm] = React.useState(false);

    const handleProximoStepForm = () => {
        let data = getValues();

        if (data.nome == "") {
            showNotification('Prencha o nome da campanha!', 'danger');
            return;
        }
        if (!validateDate(data.vigenciade)) {
            showNotification('data vigência De da campanha!', 'danger');
            return
        }
        if (!validateDate(data.vigenciaate)) {
            showNotification('data vigência ATe da campanha!', 'danger');
            return
        }

        if (data.vigenciade == "" || data.vigenciaate == "") {
            showNotification('Preencha a data de vigência da campanha!', 'danger');
            return;
        }

        if (tipoCampanha == 0) {
            showNotification('Preencha o tipo da campanha!', 'danger');
            return;
        }
        else {
            if (tipoCampanha == 1) {
                if (tipoAniversariante == 0) {
                    showNotification('Preencha o tipo de aniversariante!', 'danger');
                    return;
                }
                if (tipoAniversariante != 0) {
                    if (tipoAniversariante == 1 || tipoAniversariante == 2) {
                        if (data.valoreferencia == "") {
                            showNotification('Preencha o campo Mês/Ano corretamente!', 'danger');
                            return;
                        }
                    }
                    if (tipoAniversariante == 1) {
                        if (data.valoreferencia != "" && data.valoreferencia.length < 4) {
                            showNotification('Preencha Ano corretamente!', 'danger');
                            return;
                        }
                    }
                    if (tipoAniversariante == 2) {
                        if (data.valoreferencia != "" && data.valoreferencia.length < 2) {
                            showNotification('Preencha o Mês Ano corretamente!', 'danger');
                            return;
                        }
                    }
                }
            }
            if (tipoCampanha == 2) {
                if (jsonPacote.length == 0) {
                    showNotification('Preencha os pacotes!', 'danger');
                    return;
                }
            }
            if (tipoCampanha == 3) {
                if (jsonServico.length == 0) {
                    showNotification('Preencha os serviços!', 'danger');
                    return;
                }
            }
            if (tipoCampanha == 4) {
                if (data.periodoDe == "" || data.periodoAte == "") {
                    showNotification('Preencha o período da cortesia!', 'danger');
                    return;
                }
            }
            if (tipoCampanha == 5) {
                if (jsonCanalMidia.length == 0) {
                    showNotification('Preencha os canais de mídia!', 'danger');
                    return;
                }
            }
            if (tipoCampanha == 6) {
                if (jsonProfissao.length == 0) {
                    showNotification('Preencha as profissões!', 'danger');
                    return;
                }
            }
        }

        // constante usada para controle do DefaultValue

        setvalorreferencia(data.valoreferencia);
        let campanhaAniversariantes = [];
        campanhaAniversariantes = [
            {
                campanhaAniversarianteId: 0,
                campanhaId: campanhaId == 0 ? 0 : campanhaId,
                tipoFiltros: tipoAniversariante,
                valorReferencia: data.valoreferencia
            }
        ];

        let campanhaPacotes = [];
        jsonPacote.map(obj => {
            campanhaPacotes.push({
                campanhaPacoteId: 0,
                campanhaId: campanhaId == 0 ? 0 : campanhaId,
                pacoteId: obj
            })
        });

        let campanhaServicos = [];
        jsonServico.map(obj => {
            campanhaServicos.push({
                campanhaServicoId: 0,
                campanhaId: campanhaId == 0 ? 0 : campanhaId,
                servicoId: obj
            })
        });

        let campanhaProfissoes = [];
        jsonProfissao.map(obj => {
            campanhaProfissoes.push({
                campanhaProfissaoId: 0,
                campanhaId: campanhaId == 0 ? 0 : campanhaId,
                profissaoId: obj
            })
        });

        // constantes usadas para controle do DefaultValue
        setperiodode(convertDate(data.periodoDe));
        setperiodoate(convertDate(data.periodoAte));
        let campanhaCortesias = [];
        campanhaCortesias = [
            {
                campanhaCortesiaId: 0,
                campanhaId: campanhaId == 0 ? 0 : campanhaId,
                periodoDe: convertDate(data.periodoDe),
                periodoAte: convertDate(data.periodoAte)
            }
        ];

        let campanhaCanaisMidias = [];
        jsonCanalMidia.map(obj => {
            campanhaCanaisMidias.push({
                campanhaCanaisMidiaId: 0,
                campanhaId: campanhaId == 0 ? 0 : campanhaId,
                canalMidiaId: obj
            })
        });

        let campanha = {
            campanhaId: campanhaId == 0 ? 0 : campanhaId,
            estabelecimentoId: session.estabelecimentoId,
            nome: data.nome,
            vigenciaDe: convertDate(data.vigenciade),
            vigenciaAte: convertDate(data.vigenciaate),
            criadoPor: session.id,
            assuntoEmail: item != null ? item.assuntoEmail : "",
            corpoEmail: item != null ? item.corpoEmail : "",
            tipoCampanha: tipoCampanha,
            campanhaAniversariantes: tipoCampanha == 1 ? campanhaAniversariantes : null,
            situacao: 1,
            campanhaPacotes: tipoCampanha == 2 ? campanhaPacotes : null,
            campanhaServicos: tipoCampanha == 3 ? campanhaServicos : null,
            campanhaCortesias: tipoCampanha == 4 ? campanhaCortesias : null,
            campanhaCanaisMidias: tipoCampanha == 5 ? campanhaCanaisMidias : null,
            campanhaProfissoes: tipoCampanha == 6 ? campanhaProfissoes : null,
        };

        let endPoint = "campanhas/clientescampanha/" + disabledform + "/";
        setLoadingForm(true);
        UsePostApi(endPoint, campanha).then(result => {
            setLoadingForm(false);
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            campanha.clientesExibicao = result.data;

            setLoadingForm(false);
            handleProximoStep(campanha)
        });

    }

    return (

        <div>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />
            <HeaderStepCampanha etapa={0}></HeaderStepCampanha>

            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardBody>
                            <GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('label.campaign_name') + " *"}
                                                error={errors.nome ? true : false}
                                                variant="outlined"
                                                defaultValue=""
                                                disabled={disabledform}
                                                name="nome"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}

                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.dataDe ? true : false}
                                                label={t('label.validity_of') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                defaultValue=""
                                                disabled={disabledform}
                                                name="vigenciade"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ inputComponent: MaskDate }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.dataDe && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.dataAte ? true : false}
                                                label={t('label.validity_until') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                defaultValue=""
                                                disabled={disabledform}
                                                name="vigenciaate"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ inputComponent: MaskDate }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.dataAte && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.tipocampanha ? "select__label select__label_error" : "select__label"}>{t('label.campaign_type') + " *"} </label>
                                            <Select
                                                isDisabled={disableTipo}
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.tipocampanha ? true : false)}
                                                isSearchable={true}
                                                name="tipocampanha"
                                                placeholder={t('label.select') + " ..."}
                                                options={TiposCampanha}
                                                value={TiposCampanha.filter(({ id }) => id === tipoCampanha)}
                                                getOptionLabel={({ title }) => title}
                                                getOptionValue={({ id }) => id}
                                                onChange={(value) => handleTipoCampanha(value.id)}
                                                ref={() => register(
                                                    { name: "tipocampanha" })
                                                }
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.tipocampanha && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={2}>

                                    </GridItem>
                                    {selectedCampanhaAviversariante &&
                                        <>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.tipoaniversariante ? "select__label select__label_error" : "select__label"}>{t('label.birthday_type') + " *"} </label>
                                                    <Select
                                                        isDisabled={disabledform}
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.tipoaniversariante ? true : false)}
                                                        isSearchable={true}
                                                        name="tipoaniversariante"
                                                        placeholder={t('label.select') + " ..."}
                                                        options={TipoAniversariante}
                                                        value={TipoAniversariante.filter(({ id }) => id === tipoAniversariante)}
                                                        getOptionLabel={({ title }) => title}
                                                        getOptionValue={({ id }) => id}
                                                        onChange={(value) => handleTipoAniversariante(value.id)}
                                                        ref={() => register(
                                                            { name: "tipoaniversariante" })
                                                        }
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        fullWidth
                                                        label={tipoAniversariante == 1 ? t('label.year') + " *" : t('label.month') + " *"}
                                                        error={errors.valoreferencia ? true : false}
                                                        variant="outlined"
                                                        defaultValue={valorreferencia}
                                                        disabled={DisabledAnual ? true : disabledform ? true : false}
                                                        name="valoreferencia"
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ maxLength: tipoAniversariante == 1 ? 4 : 2 }}
                                                        inputRef={register({ required: true })}
                                                    />
                                                    <label> {tipoAniversariante == 2 ? "preencher apenas o mês da campanha ex: 04" : tipoAniversariante == 1 ? "Todos clientes que fazem aniversário esse ano" : ""}</label>
                                                </FormControl>
                                            </GridItem>
                                        </>
                                    }
                                    {selectedCampanhaPacote &&
                                        <GridItem xs={12} sm={12} md={6}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.campanhapacote ? "select__label select__label_error" : "select__label"}>{t('label.package') + " *"}</label>
                                                <Select
                                                    isDisabled={disabledform}
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.campanhapacote ? true : false)}
                                                    isSearchable={true}
                                                    isLoading={isLoadingPacote}
                                                    isMulti={true}
                                                    name="campanhapacote"
                                                    placeholder={t('label.select') + "..."}
                                                    options={listSelectPacotes}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ pacoteId }) => pacoteId}
                                                    value={listSelectPacotes.filter(({ pacoteId }) => jsonPacote.indexOf(pacoteId) != -1)}
                                                    onChange={(value) => handlePacoteChange(value || [])}
                                                    ref={() => register({ name: "campanhapacote" })
                                                    }
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.servico && <span> {t('label.required')} </span>}
                                                </FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                    }

                                    {selectedCampanhaServico &&
                                        <GridItem xs={12} sm={12} md={6}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.servico ? "select__label select__label_error" : "select__label"}>{t('label.service') + " *"}</label>
                                                <Select
                                                    isDisabled={disabledform}
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.servico ? true : false)}
                                                    isSearchable={true}
                                                    isLoading={isLoadingServico}
                                                    isMulti={true}
                                                    name="campanhaservico"
                                                    placeholder={t('label.select') + "..."}
                                                    options={listSelectServicos}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ servicoId }) => servicoId}
                                                    value={listSelectServicos.filter(({ servicoId }) => jsonServico.indexOf(servicoId) != -1)}
                                                    onChange={(value) => handleServicoChange(value || [])}
                                                    ref={() => register({ name: "campanhaservico" })
                                                    }
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.servico && <span> {t('label.required')} </span>}
                                                </FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                    }

                                    {selectedCampanhaCanalMidia &&
                                        <GridItem xs={12} sm={12} md={6}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.servico ? "select__label select__label_error" : "select__label"}>{t('label.midia_channel') + " *"}</label>
                                                <Select
                                                    isDisabled={disabledform}
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.campanhacanalmidia ? true : false)}
                                                    isSearchable={true}
                                                    isLoading={isLoadingCanalMidia}
                                                    isMulti={true}
                                                    name="campanhacanalmidia"
                                                    placeholder={t('label.select') + "..."}
                                                    options={listSelectCanalMidia}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ canalMidiaId }) => canalMidiaId}
                                                    value={listSelectCanalMidia.filter(({ canalMidiaId }) => jsonCanalMidia.indexOf(canalMidiaId) != -1)}
                                                    onChange={(value) => handleCanalMidiaChange(value || [])}
                                                    ref={() => register({ name: "campanhacanalmidia" })
                                                    }
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.campanhacanalmidia && <span> {t('label.required')} </span>}
                                                </FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                    }

                                    {selectedCampanhaCortesia &&
                                        <>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.periodoDe ? true : false}
                                                        label={t('label.period_of') + " *"}
                                                        variant="outlined"
                                                        inputRef={register({ required: true })}
                                                        defaultValue={periodode}
                                                        disabled={disabledform}
                                                        name="periodoDe"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ inputComponent: MaskDate }}
                                                    />
                                                    <FormHelperText className={classes.labelRootError}>
                                                        {errors.periodoDe && <span>{t('label.required')}</span>}
                                                    </FormHelperText>
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.periodoAte ? true : false}
                                                        label={t('label.period_until') + " *"}
                                                        variant="outlined"
                                                        inputRef={register({ required: true })}
                                                        defaultValue={periodoate}
                                                        disabled={disabledform}
                                                        name="periodoAte"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ inputComponent: MaskDate }}
                                                    />
                                                    <FormHelperText className={classes.labelRootError}>
                                                        {errors.periodoAte && <span>{t('label.required')}</span>}
                                                    </FormHelperText>
                                                </FormControl>
                                            </GridItem>
                                        </>
                                    }
                            {selectedCampanhaProfissao &&
                                        <GridItem xs={12} sm={12} md={6}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.profissao ? "select__label select__label_error" : "select__label"}>{t('label.profession') + " *"}</label>
                                                <Select
                                                    isDisabled={disabledform}
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.campanhaprofissao ? true : false)}
                                                    isSearchable={true}
                                                    isLoading={isLoadingProfissao}
                                                    isMulti={true}
                                                    name="campanhaprofissao"
                                                    placeholder={t('label.select') + "..."}
                                                    options={listSelectProfissoes}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ profissaoId }) => profissaoId}
                                                    value={listSelectProfissoes.filter(({ profissaoId }) => jsonProfissao.indexOf(profissaoId) != -1)}
                                                    onChange={(value) => handleProfissaoChange(value || [])}
                                                    ref={() => register({ name: "campanhaprofissao" })
                                                    }
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.campanhaprofissao && <span> {t('label.required')} </span>}
                                                </FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                    }
                                </GridContainer>
                                {
                                    descricaoTipo &&
                                    <SnackbarContent
                                        color={"info"}
                                        message={descricaoTipo}
                                    />
                                }
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <Button onClick={() => handleCancelarForm()} color="transparent" className={classes.updateProfileButton}>
                        {t('button.cancel')}
                    </Button>
                    <Button onClick={() => handleProximoStepForm()} color="primary" className={classes.updateProfileButton}>
                        {t('button.next')}  {LoadingForm && <div> ... {t('label.loading')}</div>}
                    </Button>
                </GridItem>
            </GridContainer>

        </div>
    );
}